<template>
    <div class="page-block__item">
        <div class="page-block__item-content">
            <div class="layout">
                <div class="layout__item u-1/3-desk">
                    <span class="page-block__item-content-title">
                        {{ label }}
                    </span>
                </div>
                <!--
             -->
                <div class="layout__item u-2/3-desk">
                    {{ type }}
                </div>
            </div>
        </div>

        <!-- TODO: Make editing of hosting possible -->
        <div v-if="modifiable && false" class="page-block__item-nav">
            <router-link :to="{ name: '' }">
                <button type="button" class="btn btn--ghost btn--ghost-full-width">
                    {{ modifyLabel }}
                </button>
            </router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        modifiable: {
            type: Boolean
        },
        modifyLabel: {
            type: String
        }
    }
};
</script>
